import { render } from "./BlFormFieldMulticheckbox.vue?vue&type=template&id=56fce10f&scoped=true"
import script from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"
export * from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"

import "./BlFormFieldMulticheckbox.vue?vue&type=style&index=0&id=56fce10f&scoped=true&lang=css"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fce10f"]])

export default __exports__